// Angular modules
import { Pipe }          from '@angular/core';
import { PipeTransform } from '@angular/core';

@Pipe({
  name : 'whereIn'
})
export class WhereInPipe implements PipeTransform
{
  transform(items: any[], filter: Array<string>) : string[]
  {
    if (!items || !filter) {
        return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter(item => filter.indexOf(item.key)>=0);
  }
}